function createPalette(
  main,
  highlight,
  border,
  contrastText,
  contrastTextMuted,
  subtle,
  subtleHighlight,
  subtleBorder,
  subtleContrastText,
  subtleContrastTextMuted,
) {
  return {
    main,
    dark: highlight,
    highlight,
    border,
    contrastText,
    contrastTextMuted,
    subtle,
    subtleHighlight,
    subtleBorder,
    subtleContrastText,
    subtleContrastTextMuted,
  };
}

export const LIGHT = {
  primary: createPalette(
    '#3281E2',
    '#2076DF',
    '#8BB8EE',
    '#E4EFFB',
    '#A6C8F2',
    '#E4EFFB',
    '#D2E4F9',
    '#B8D3F5',
    '#195EB3',
    '#4985D0',
  ),
  error: createPalette(
    '#DA2F57',
    '#D0254D',
    '#EA869D',
    '#FAE5EA',
    '#F3BAC7',
    '#FAE5EA',
    '#F7D4DC',
    '#F3BAC7',
    '#AD1F40',
    '#CA4E6B',
  ),
  secondary: createPalette(
    '#ffffff',
    '#f5f7fa',
    '#dbe2ea',
    '#64748b',
    '#94a3b8',
    '#FBFCFD',
    '#f5f7fa',
    '#dbe2ea',
    '#64748b',
    '#94a3b8',
  ),
  success: createPalette(
    '#5AAF5E',
    '#50A554',
    '#9FD1A1',
    '#EAF5EB',
    '#C8E4C9',
    '#EAF5EB',
    '#DDEEDD',
    '#C8E4C9',
    '#428A46',
    '#76A279',
  ),
  warning: createPalette(
    '#E9BA4E',
    '#E4AB26',
    '#FFCD61',
    '#FFF5E0',
    '#FFE5AD',
    '#FFF5E0',
    '#FFEFCC',
    '#FFE5AD',
    '#CC8B00',
    '#EDB02C',
  ),
  info: createPalette(
    '#B563C5',
    '#AE54C0',
    '#D8ADE1',
    '#F4E9F7',
    '#E3C3E9',
    '#F4E9F7',
    '#EDDAF1',
    '#E3C3E9',
    '#853795',
    '#A36AAF',
  ),
  note: createPalette(
    '#F273B3',
    '#F060A8',
    '#F9BDDC',
    '#FCE3F0',
    '#F8B4D6',
    '#FCE3F0',
    '#FBD0E6',
    '#F8B4D6',
    '#BB1166',
    '#D93F8C',
  ),
  neutral: createPalette(
    '#94A3B8',
    '#8898AF',
    '#D1D7E0',
    '#EDEFF3',
    '#CED5DE',
    '#EDEFF3',
    '#E0E5EB',
    '#CED5DE',
    '#52637A',
    '#7C8A9C',
  ),
  orange: createPalette(
    '#F59051',
    '#F4843E',
    '#FBCEB2',
    '#FDEDE2',
    '#FBCEB2',
    '#FDEDE2',
    '#FCE0CF',
    '#FBCEB2',
    '#C1510B',
    '#E07938',
  ),
  text: {
    primary: '#334155',
    secondary: '#64748B',
    subtle: '#94A3B8',
    variant: '#FFFFFF',
  },
  paper: '#FFFFFF',
  background: {
    default: '#FBFCFD',
    paper: '#FFFFFF',
    paper2: '#FBFCFD',
    paper2Variant: '#FFFFFF',
    paper3: '#F8FAFC',
    paper4: '#F1F5F9',
    paper5: '#FFFFFF',
    paper5Variant: '#FFFFFF',
  },
  divider: '#DBE2EA',
  dividerVariant: '#DBE2EA',
  action: {
    highlight: '#E5F0FA',
    highlightContrastText: '#1F6BAD',
    highlightContrastTextMuted: '#4486C1',
    highlightBorder: '#BBD8F2',
    highlightVariant: '#EEF5FB',
  },
  tooltip: '#334155',
  input: {
    background: '#FFFFFF',
    highlight: '#3281E2',
    readOnly: '#F8FAFC',
  },
  sidebar: createPalette(
    '#123C63',
    '#154674',
    '#1A568E',
    '#E5F0FA',
    '#7A9AB8',
    '#E5F0FA',
    '#D4E6F7',
    '#B8CDE0',
    '#184E81',
    '#5B8BB9',
  ),
};

export const DARK = {
  primary: createPalette(
    '#8EC0EC',
    '#A3CCEF',
    '#568DBD',
    '#0F3557',
    '#2E4F6B',
    '#2B4861',
    '#1E2F3D',
    '#4878A3',
    '#B9D8F3',
    '#87A5C0',
  ),
  secondary: createPalette(
    '#2b2f40',
    '#33374c',
    '#424762',
    '#8389a5',
    '#52597a',
    '#252837',
    '#33374c',
    '#424762',
    '#8389a5',
    '#52597a',
  ),
  error: createPalette(
    '#F16565',
    '#F37C7C',
    '#C44F4F',
    '#5D0909',
    '#6B2E2E',
    '#492727',
    '#3D2929',
    '#784040',
    '#F6A2A2',
    '#B87A7A',
  ),
  orange: createPalette(
    '#FD9858',
    '#FEA772',
    '#D66C29',
    '#652701',
    '#6B452E',
    '#493427',
    '#3D3129',
    '#644735',
    '#FEC09A',
    '#B8927A',
  ),
  success: createPalette(
    '#7CB766',
    '#8BBF78',
    '#558B41',
    '#2A4521',
    '#3E6B2E',
    '#304927',
    '#2E3D29',
    '#406034',
    '#C3DEBA',
    '#8BB87A',
  ),
  warning: createPalette(
    '#FFD966',
    '#FFDF80',
    '#E0A900',
    '#664D00',
    '#6B5C2E',
    '#494127',
    '#3D3829',
    '#645835',
    '#FFE699',
    '#B8A87A',
  ),
  purple: createPalette(
    '#AD8FDC',
    '#BBA2E2',
    '#8460BE',
    '#2E184E',
    '#462E6B',
    '#352749',
    '#31293D',
    '#483564',
    '#C7B1E7',
    '#937AB8',
  ),
  note: createPalette(
    '#ED91BF',
    '#F1A7CC',
    '#C46E99',
    '#580E33',
    '#6B2E4D',
    '#492738',
    '#3D2933',
    '#64354D',
    '#F1A7CC',
    '#B87A99',
  ),
  neutral: createPalette(
    '#CBD5E1',
    '#D8E0E9',
    '#91A6C0',
    '#384A61',
    '#667D99',
    '#454C54',
    '#4E565F',
    '#57606A',
    '#BECBDA',
    '#8997A9',
  ),
  text: {
    primary: '#D1D4E0',
    secondary: '#8389A5',
    subtle: '#52597A',
    variant: '#D1D4E0',
  },
  paper: '#212330',
  background: {
    default: '#252837',
    paper: '#212330',
    paper2: '#252837',
    paper2Variant: '#252837',
    paper3: '#292C3D',
    paper4: '#2D3143',
    paper5: '#2B2F40',
    paper5Variant: '#3B4158',
  },
  divider: '#35394F',
  dividerVariant: '#464B68',
  action: {
    highlight: '#243C51',
    highlightContrastText: '#B9D8F3',
    highlightContrastTextMuted: '#87A5C0',
    highlightBorder: '#3F688D',
    highlightVariant: '#252E3F',
  },
  input: {
    background: '#2D3243',
    highlight: '#5982A6',
    readOnly: '#373C52',
  },
  tooltip: '#313649',

  sidebar: createPalette(
    '#1B1D27',
    '#262836',
    '#303445',
    '#E1E2EA',
    '#8389A5',
    '#2A2D3C',
    '#313549',
    '#697096',
    '#C3C6D5',
    '#8389A5',
  ),
};
